import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import {
  CONFERENCE,
  CONFERENCE_ALL,
  CONFERENCE_ARTICLE_BY_ID,
  CONFERENCE_ARTICLE_ALL,
  CONFERENCE_ARTICLE_CREATE,
  CONFERENCE_CATEGORY_ALL,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const conference = createAsyncThunk(
  CONFERENCE,
  async (params: PayloadCreatorParams<`${typeof API.CONFERENCE}{id}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.conference(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const conferenceAll = createAsyncThunk(
  CONFERENCE_ALL,
  async (params: PayloadCreatorParams<`${typeof API.CONFERENCE_ALL}`, 'get'> | undefined, { rejectWithValue }) => {
    try {
      const response = await api.conferenceAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const conferenceArticleCreate = createAsyncThunk(
  CONFERENCE_ARTICLE_CREATE,
  async (params: PayloadCreatorParams<`${typeof API.CONFERENCE_ARTICLE}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.conferenceArticleCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const conferenceArticle = createAsyncThunk(
  CONFERENCE_ARTICLE_BY_ID,
  async (
    params: PayloadCreatorParams<`${typeof API.CONFERENCE_ARTICLE_BY_ID}{id}`, 'get'>,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.conferenceArticle(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const conferenceArticleAll = createAsyncThunk(
  CONFERENCE_ARTICLE_ALL,
  async (
    params: PayloadCreatorParams<`${typeof API.CONFERENCE_ARTICLE_ALL}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.conferenceArticleAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const conferenceCategoryAll = createAsyncThunk(
  CONFERENCE_CATEGORY_ALL,
  async (
    params: PayloadCreatorParams<`${typeof API.CONFERENCE_CATEGORY_ALL}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.conferenceCategoryAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)
export const conferenceClear = createAction(`${CONFERENCE}/clear`)

export const conferenceArticleClear = createAction(`${CONFERENCE_ARTICLE_BY_ID}/clear`)

export const conferenceArticleAllClear = createAction(`${CONFERENCE_ARTICLE_ALL}/clear`)

export const conferenceCategoryAllClear = createAction(`${CONFERENCE_CATEGORY_ALL}/clear`)

export const conferenceAllClear = createAction(`${CONFERENCE_ALL}/clear`)
